module.exports = __webpack_public_path__ + "media/managing_your_money/invest_feature_article_img-3b346a7c.png";